<template>
  <div class="DeepInfo flex flex-col h-screen bg-yellow">
    <div class="logo-header-container ml-8 mt-8">
      <div class="logo-header flex">
        <div class="logo w-32">
          <img class="w-full" src="https://blissing.s3-us-west-1.amazonaws.com/img/blissing_UN_logo_icon_v02.png" alt="blissing blue image logo">
        </div>
        <div class="flex flex-col ml-4">
          <img class="blissing-logo" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING_BW.png" alt="blissing text logo">
          <span class="text-2xl text-left ml-1 font-bold border-4ads border-b-4 leading-none self-start mt-1">DEEP INFO FOR EXPERTS</span>
        </div>
      </div>
    </div>

    <ConceptIndex v-if="section == 'index'"/>
    <ConceptSubOne v-if="section == 'sub-concept-one'" :pdfUrl="pdfBaseUrl + pdfs.concept_1"/>
    <ConceptSubTwo v-if="section == 'sub-concept-two'" :pdfUrl="pdfBaseUrl + pdfs.concept_2"/>
    <ConceptSubThree v-if="section == 'sub-concept-three'" :pdfUrl="pdfBaseUrl + pdfs.concept_3"/>
    <ConceptSubFour v-if="section == 'sub-concept-four'" :pdfUrl="pdfBaseUrl + pdfs.concept_4"/>

    <div v-if="section == 'index'" class="bottom-text">
      <h1 class="font-bold italic">Part 3: Concept Information</h1>
    </div>

    <div @click="goBack()" class="h-16 w-16 absolute bottom-0 ml-10 mb-10 z-50">
      <img class="arrow up cursor-pointer" src="https://blissing.s3-us-west-1.amazonaws.com/img/Arrow-up.png" alt="arrow up">
    </div>

    <Navigation textColor="black"/>

  </div>
</template>

<script>
import ConceptIndex from "@/components/deepinfo/concept/Index.vue";
import ConceptSubOne from "@/components/deepinfo/concept/SubOne.vue";
import ConceptSubTwo from "@/components/deepinfo/concept/SubTwo.vue";
import ConceptSubThree from "@/components/deepinfo/concept/SubThree.vue";
import ConceptSubFour from "@/components/deepinfo/concept/SubFour.vue";
import Navigation from "@/components/Navigation.vue";
import {mapState} from "vuex";

export default {
  name: "DeepInfoConcept",
  components:{
    ConceptIndex,
    ConceptSubOne,
    ConceptSubTwo,
    ConceptSubThree,
    ConceptSubFour,
    Navigation
  },
  data(){
    return{
      section: 'index',
      pdfs:{
        concept_1: 'deep_info/Art+Production+Process+%26+Costs.pdf',
        concept_2: 'deep_info/3+Types+of+Music.pdf',
        concept_3: 'deep_info/Process+Module+-+Streams.pdf',
        concept_4: 'deep_info/The+Hall+of+Eternity.pdf',
      }
    }
  },
  methods:{
    showCard(card){
      if (card != 'deep-info-main-menu') {
        this.section = card;
      } else {
        this.$router.push({name: 'DeepInfo'});
      }
    },
    goBack(){
      if (this.section == 'index') {
        this.$router.go(-1);
      }else {
        this.showCard('index');
      }
    }
  },
  computed: {
   ...mapState(["pdfBaseUrl"])
 },
  mounted(){
    Event.$on('clickedCard', (data) => {this.showCard(data)});
  }
}
</script>

<style lang="css" scoped>
.blissing-logo{
  width: 20rem;
}

</style>
